import type { PersonalDataTranslations } from './personalData.translation.pl.ts';

export const personalDataTranslations: PersonalDataTranslations = {
  heading: 'Parle-nous un peu de toi',
  areasHeading: 'Domaines pour lesquels je postule',
  areasDescription: "Choisis jusqu'à 3 domaines et définis leurs priorités",
  checkboxText: "Je déclare avoir pris connaissance du règlement et l'accepter.",
  areasSelection: {
    instruction: "Choisis les domaines qui t'intéressent le plus :",
    proceed: 'Passer aux priorités',
  },
  areasPrioritization: {
    instruction: 'Fais glisser les domaines pour définir leur ordre (1 = priorité la plus haute) :',
    backToSelection: '← Retour à la sélection',
  },
  fields: {
    firstName: 'Prénom',
    lastName: 'Nom',
    phoneNumber: 'Numéro de téléphone (chiffres uniquement)',
    fieldOfStudy: "Domaine d'études",
    graduationYear: {
      label: "Année d'études / diplômé(e)",
      placeholder: "Année d'études terminée",
    },
    studentStatus: 'Statut',
    universityName: "Nom de l'établissement",
    location: { label: 'Ville', placeholder: 'Ville où tu souhaites faire ton stage' },
    typeOfStudy: "Type d'études",
    aboutYourself: {
      label: 'Dis-nous quelque chose sur toi',
      placeholder:
        'Cet espace est à toi - raconte-nous ce qui te motive, mets en avant tes réussites ou les projets auxquels tu as participé',
    },
    areaDescription: {
      label: 'Domaine métier',
      placeholder: 'Quel domaine te correspond le plus et pourquoi ? Dis-le-nous !',
    },
    isUnder30: 'Je confirme avoir moins de 30 ans',
    linkedinUrl: 'Lien LinkedIn',
    githubUrl: 'Lien GitHub ou portfolio',
    notRequired: 'Facultatif',
    required: 'champ obligatoire',
  },
  graduationYearOptions: {
    placeholder: "Année d'études / diplômé(e)",
    '2': '2e année',
    '3': '3e année',
    '4': '4e année',
    '5': '5e année',
    '6': 'Diplômé(e) de moins de 30 ans',
  },
  button: {
    back: 'Retour',
    next: 'Suivant',
  },
  errors: {
    phoneNumberMin: 'Le numéro de téléphone doit comporter au moins 9 chiffres',
  },
  dropdown: {
    search: 'Rechercher...',
    noResults: 'Aucun résultat',
  },
  university: {
    addCustom: 'Ajouter le tien :',
    selectFromList: 'Sélectionne dans la liste ci-dessus',
  },
};
